import React, { useContext, useEffect, useState } from "react";
import style from "../style/Header.module.scss";
import end_logo from "/end_logo.svg";
import end_logo_name from "/end_logo_name.svg";
import styled from "styled-components";
import { Menu, MenuItem } from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";
import { NoticeDataContext } from "../contexts/NoticeDataContext";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useLayoutEffect } from "react";
import Logger from "../libraries/Logger";

const Btn = styled.div`
  position: absolute;
  top: -10px;
  right: -50px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  border: 1px solid #ccc;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  transform: ${({ isOpen }) => (isOpen ? `initail` : `rotate(180deg)`)};
  &:hover {
    border: 1px #000 solid;
  }
`;

function Header({
  sidebarOpen,
  setSidebarOpen,
  setOpen,
  open,
  noticeData,
  closeConnection,
}) {
  const navigate = useNavigate();
  const [account, setAccount] = useState("");
  const [name, setName] = useState("");
  const [noticeCount, setNoticeCount] = useState(1);
  const [AccountId, setAccountId] = useState("");
  const { myAuth } = useContext(AuthContext);
  const isAdmin = myAuth.IsAdmin;
  //臨時帳號(不可登出)
  const [isTemp, setIsTemp] = useState(false);

  useEffect(() => {
    setAccount(
      JSON.parse(localStorage.getItem("auth"))?.Account ||
        JSON.parse(localStorage.getItem("auth"))?.AccountPhone
    );
    setName(JSON.parse(localStorage.getItem("auth"))?.Name);
    setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
    setIsTemp(JSON.parse(localStorage.getItem("auth"))?.IsTempAccount);
  }, []);
  // useEffect(() => {
  //   setNoticeCount(JSON.parse(localStorage.getItem("noticeData"))?.length);
  // }, []);
  //console.log(noticeCount);
  const { logout } = useContext(AuthContext);
  const { nData, setNData, refreshNData, setRefreshNData } =
    useContext(NoticeDataContext);

  const changeState = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    if (noticeData?.UnReaded === false) {
      setNoticeCount(0);
    } else {
      setNoticeCount(1);
    }
  }, [noticeData]);
  //console.log(noticeData);

  const [anchorEl, setAnchorEl] = useState(null);
  const openOther = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotice = () => {
    setOpen(true);
    setNoticeCount(0);
    //localStorage.setItem("noticeData", JSON.stringify([]));
    //setNoticeCount(JSON.parse(localStorage.getItem("noticeData"))?.length);
    // console.log(123);
  };

  // const { data, mutate } = useMutation();
  return (
    <div className={style.headerBody}>
      <div className={style.header_mobile}>
        <img src={end_logo} className={style.end_logo} />
        <img
          src={end_logo_name}
          className={style.end_logo_name}
          onClick={() => {
            navigate("/ReferralDataList");
          }}
          style={{ cursor: "pointer" }}
        />
        <Btn
          className={style.sidebarBtn}
          isOpen={sidebarOpen}
          onClick={changeState}
        >
          <i
            className="fa-solid fa-arrow-left"
            style={{ color: "#E0E0E0" }}
          ></i>
        </Btn>
      </div>
      <div className={style.header_btn}>
        <div className={style.headerBell} onClick={handleNotice}>
          <i className={`${style.bellIcon} fa-solid fa-bell`}></i>
          <div
            className={style.noticeNumber}
            style={{ display: noticeCount === 1 ? "block" : "none" }}
          ></div>
        </div>
        <div
          className={style.headerUser}
          aria-controls={openOther ? "demo-positioned-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openOther ? "true" : undefined}
          onClick={handleClick}
        >
          <i className={`${style.userIcon} fa-solid fa-circle-user`}></i>
        </div>
        <Menu
          id="demo-positioned-menu"
          anchorEl={anchorEl}
          open={openOther}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose();
              navigate(`/AccountEdit?rowId=${AccountId}`);
            }}
            style={{ backgroundColor: "#f2f2f2" }}
          >
            <i
              className={`${style.userIcon} fa-solid fa-circle-user`}
              style={{ margin: "8px" }}
            ></i>
            <div>
              <div style={{ fontSize: "12px" }}>{name}</div>
              <div style={{ fontSize: "12px" }}>{account}</div>
            </div>
          </MenuItem>
          <MenuItem
            onClick={() => {
              logout();
              closeConnection();
            }}
            style={{ fontSize: "14px" }}
            disabled={isTemp}
          >
            登出
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
}

export default Header;
